export default "__VITE_ASSET__DlNkD3xE__"